<template>
  <el-form ref="ruleFormRef" :model="form" status-icon label-width="120px" class="demo-ruleForm remark">
    <h2>风控备注</h2>
    <el-row class="mt10">
      <el-col :span="3" style="line-height: 32px;">
        <h3>备注说明:</h3>
      </el-col>
      <el-col :span="8" class="d-s-c d-r">
        <el-form-item label-width="0" prop="remarks_risk">
          <el-input v-model="form.remarks_risk" type="textarea"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="3">
        <h3>上传图片证明</h3>
      </el-col>
      <el-col :span="8">
        <!-- 点击按钮上传图片 -->
        <el-row>
          <div class="d-s-c d-r" style="width: fit-content; box-sizing: border-box;">
            <div class="pr img-wrap p10" style="height: 100%;">
              <img v-img-url="form.remarks_risk_image" style="border-radius: 6px;border: solid 1px #d7e0e9;"
                height="100" alt="预览图" />
            </div>
            <div class="hover_group pr">
              <el-button type="primary" size="small" class="btn-select"
                @click="openUpload('image', 'remarks_risk_image')">选择图片</el-button>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="3">
        <h3>上传视频证明</h3>
      </el-col>
      <el-col :span="8">
        <!-- 点击按钮上传 -->
        <el-row>
          <div class="d-s-c d-r" style="width: fit-content; box-sizing: border-box;">
            <div class="pr img-wrap p10" style="height: 100%;">
              <video :src="form.remarks_risk_video"
                style="border-radius: 6px;border: solid 1px #d1dfec; aspect-ratio: 16/9;" height="100"
                class="video-preview" />
            </div>
            <div class="hover_group pr">
              <el-button type="primary" size="small" class="btn-select "
                @click="openUpload('video', 'remarks_risk_video')">选择视频</el-button>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <h2>企业资料</h2>
    <el-row class="mt10">
      <el-col :span="3" style="line-height: 32px;">
        <h3>企业法人证明:</h3>
      </el-col>
      <el-col :span="8" class="d-s-c d-r">
        <el-form-item label-width="0" prop="legal_image">
          <el-input v-model="form.legal_image"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="3" style="line-height: 32px;">
        <h3>法人手机号:</h3>
      </el-col>
      <el-col :span="8" class="d-s-c d-r">
        <el-form-item label-width="0" prop="legal_mobile">
          <el-input v-model="form.legal_mobile"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="3">
        <h3>身份证头像面：</h3>
      </el-col>
      <el-col :span="8">
        <!-- 点击按钮上传图片 -->
        <el-row>
          <div class="d-s-c d-r" style="width: fit-content; box-sizing: border-box;">
            <div class="pr img-wrap p10" style="height: 100%;">
              <img v-img-url="form.legal_z_card" style="border-radius: 6px;border: solid 1px #d7e0e9;" height="100"
                alt="预览图" />
            </div>
            <div class="hover_group pr">
              <el-button type="primary" size="small" class="btn-select "
                @click="openUpload('image', 'legal_z_card')">选择图片</el-button>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="3">
        <h3>身份证国徽面：</h3>
      </el-col>
      <el-col :span="8">
        <!-- 点击按钮上传图片 -->
        <el-row>
          <div class="d-s-c d-r" style="width: fit-content; box-sizing: border-box;">
            <div class="pr img-wrap p10" style="height: 100%;">
              <img v-img-url="form.legal_f_card" style="border-radius: 6px;border: solid 1px #d7e0e9;" height="100"
                alt="预览图" />
            </div>
            <div class="hover_group pr">
              <el-button type="primary" size="small" class="btn-select "
                @click="openUpload('image', 'legal_f_card')">选择图片</el-button>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="3">
        <h3>营业执照：</h3>
      </el-col>
      <el-col :span="8">
        <!-- 点击按钮上传图片 -->
        <el-row>
          <div class="d-s-c d-r" style="width: fit-content; box-sizing: border-box;">
            <div class="pr img-wrap p10" style="height: 100%;">
              <img v-img-url="form.business_license" style="border-radius: 6px;border: solid 1px #d7e0e9;" height="100"
                align="middle" alt="预览图" />
            </div>
            <div class="hover_group pr">
              <el-button type="primary" size="small" class="btn-select "
                @click="openUpload('image', 'business_license')">选择图片</el-button>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="3">
        <h3>企业工作环境视频：</h3>
      </el-col>
      <el-col :span="8">
        <!-- 点击按钮上传视频 -->
        <el-row>
          <div class="d-s-c d-r" style="width: fit-content; box-sizing: border-box;">
            <div class="pr img-wrap p10" style="height: 100%;">
              <video :src="form.environment" style="border-radius: 6px;border: solid 1px #d1dfec; aspect-ratio: 16/9;"
                height="100" class="video-preview" />
            </div>
            <div class="hover_group pr">
              <el-button type="primary" size="small" class="btn-select "
                @click="openUpload('image', 'environment')">选择视频</el-button>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mt10">
      <el-col :span="11" class="d-e-c"> </el-col>
    </el-row>
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button type="primary" size="middle" @click="submitOderInfo">
        提交
      </el-button>
      <el-button type="info" @click="resetForm">重置</el-button>
    </div>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnFilesFunc">上传图片
    </Upload>
  </el-form>
</template>

<script>
import Upload from "@/components/file/Upload";
import OrderApi from "@/api/order.js";
import fileHandle from "@/api/fileHandle.js";

export default {
  components: {
    Upload
  },
  props: {
    detail: Object
  },
  data() {
    return {
      isProductUpload: false,
      pathName: "",
      config: {
        total: -1,
        file_type: ""
      },

      form: {
        /*
          风险备注、风险照片、风险视频
        */
        order_id: "",
        remarks_risk: "", // 风险备注
        remarks_risk_image: "", // 风险照片
        remarks_risk_video: "", // 风险视频

        /*
          法人证明、手机号码、身份证头像面、身份证国徽面、营业执照、企业工作环境视频
        */
        legal_image: "", // 法人证明
        legal_mobile: "", // 手机号码
        legal_z_card: "", // 身份证头像面
        legal_f_card: "", // 身份证国徽面
        business_license: "", // 营业执照
        environment: "" // 企业工作环境视频
      }
    };
  },
  methods: {
    /*打开上传图片*/
    openUpload: function (type, key) {
      this.pathName = key;
      this.config.file_type = type;
      type == "image" && (this.config.total = 9);
      type == "video" && (this.config.total = 1);
      this.isProductUpload = true;
    },
    /*上传商品图片*/
    returnFilesFunc(e) {
      if (e !== null) {
        this.form[this.pathName] = e[0].file_path;
      }
      this.isProductUpload = false;
    },
    submitOderInfo() {
      const self = this;
      const params = {
        ...self.form,
        order_id: self.$route.query.order_id
      };

      console.log("params", params);
      OrderApi.updateOrderInfo(params, true);
      self.$message({
            message: "提交成功",
            type: "success",
          });
    },
    resetForm() {
      this.form = {
        /*
          风险备注、风险照片、风险视频
        */
        order_id: "",
        remarks_risk: "", // 风险备注
        remarks_risk_image: "", // 风险照片
        remarks_risk_video: "", // 风险视频

        /*
          法人证明、手机号码、身份证头像面、身份证国徽面、营业执照、企业工作环境视频
        */
        legal_image: "", // 法人证明
        legal_mobile: "", // 手机号码
        legal_z_card: "", // 身份证头像面
        legal_f_card: "", // 身份证国徽面
        business_license: "", // 营业执照
        environment: "" // 企业工作环境视频
      }
    }
  },
  created() {
    console.log(this.detail);

    // const {
    //   order_id,
    //   remarks_risk,
    //   remarks_risk_image,
    //   legal_image,
    //   legal_mobile,
    //   legal_z_card,
    //   legal_f_card,
    //   business_license,
    //   environment
    // } = this.detail;
      this.form.order_id = this.detail.order_id;  
      this.form.remarks_risk = this.detail.remarks_risk;  
      this.form.remarks_risk_image = this.detail.remarks_risk_image;  
      this.form.remarks_risk_video = this.detail.remarks_risk_video;  
      this.form.legal_image = this.detail.legal_image;  
      this.form.legal_mobile = this.detail.legal_mobile;  
      this.form.legal_z_card = this.detail.legal_z_card;  
      this.form.legal_f_card = this.detail.legal_f_card;  
      this.form.business_license = this.detail.business_license;  
      this.form.environment = this.detail.environment;  
    console.log(this.form,'orm');

  }
};
</script>

<style lang="scss" scoped>
.remark {
  &>.el-row {
    width: 96%;
  }

  &>.el-row {
    min-width: 1200px;
  }

  .el-form-item {
    width: 100%;
    padding: 0;
  }

  .hover_group {
    height: 100px;

    &:hover {

      // background-color: rgba($color: #000000, $alpha: 0.1);
      .btn-select {
        display: block;
      }
    }
  }

  .btn-select {
    // display: none;
    height: 24px;
    width: 60px;
    padding: 0;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
  }

  .video-preview {
    z-index: -1;
    pointer-events: none;
  }

  .w270 {
    width: 270px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/remark.vue